// extracted by mini-css-extract-plugin
module.exports = {"close":"Modal_close__3rW_Y","title":"Modal_title__kbqpq"};